import { Idevice } from "../../../types/device";
import ObContainerDesk from "./obContainerDesk";
import React, { ReactNode } from "react";
import ObContainerTab from "./obContainerTab";
import ObContainerMob from "./obContainerMob";
import DeviceContext from "../../../service/indentifyDevice";
import { IListObj } from "../../../types/genericTypes";

export const SDevWiseStateComp = (
	priNavOptions: Array<IListObj>,

	instrument: ReactNode,
	hidepgNav: boolean,
	handleDevice: Idevice = DeviceContext(),
	handleInstNav?: (data: string) => void
) => {
	return (
		<section className="obSection">
			{handleDevice.isDesktop && (
				<ObContainerDesk priNavOptions={priNavOptions} instComp={instrument} isPriNavHidden={hidepgNav} handleInstNav={handleInstNav} />
			)}
			{handleDevice.isTablet && (
				<ObContainerTab priNavOptions={priNavOptions} instComp={instrument} isPriNavHidden={hidepgNav} handleInstNav={handleInstNav} />
			)}
			{handleDevice.isMobile && (
				<ObContainerMob priNavOptions={priNavOptions} instComp={instrument} isPriNavHidden={hidepgNav} handleInstNav={handleInstNav} />
			)}
		</section>
	);
};
